import * as CryptoJS from 'crypto-js';
import { ENCRYPTED_DATA } from '../../secure-data/encrypted-data';

export function decrypt(encryptedHex) {

    const encryptedWords = CryptoJS.enc.Hex.parse(encryptedHex);
    
    const iv = CryptoJS.lib.WordArray.create(encryptedWords.words.slice(0, 4), 16);
    const ciphertext = CryptoJS.lib.WordArray.create(
        encryptedWords.words.slice(4),
        encryptedWords.sigBytes - 16
    );

    const keyWA = CryptoJS.enc.Utf8.parse(ENCRYPTED_DATA.secretKey);

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: ciphertext },
        keyWA,
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
}